import { dictTypeDataAll } from '@/api/system/dict/data'

const useDictStore = defineStore(
  'dict',
  {
    state: () => ({
      dict: {}
    }),
    actions: {
      async init() {
        const res = await dictTypeDataAll();
        if (res && res.code == 200) {
          Object.keys(res.data).forEach(key => {
            this.dict[key] = res.data[key].map(p => ({ dictLabel: p.dictLabel, dictValue: p.dictValue, elTagType: p.listClass, elTagClass: p.cssClass,
              hasPermi: p.hasPermi
             }));
          })
        }
      },
      // 获取字典
      getDict(_key) {
        if (_key == null && _key == "") {
          return null;
        }
        try {
          return this.dict[_key];
        } catch (e) {
          return null;
        }
      },
      // 设置字典
      setDict(_key, value) {
        if (_key !== null && _key !== "") {
          this.dict[_key] = value;
        }
      },
      // 删除字典
      removeDict(_key) {
        var bln = false;
        try {
          delete this.dict[_key];
          return true
        } catch (e) {
          bln = false;
        }
        return bln;
      },
      // 清空字典
      cleanDict() {
        this.dict = {};
      },
      // 初始字典
      initDict() {
      }
    }
  })

export default useDictStore
